import { CONFERENCE_LEFT } from "../base/conference";
import { ReducerRegistry, StateListenerRegistry } from "../base/redux";
import { CLEAR_GROUP_LIST, DELETE_GROUP_LIST, INIT_GROUP_LIST, SET_ASSIGN_GROUP_ID, SET_GROUP_COMPONENT_TYPE, SET_GROUP_FOCUS, SET_GROUP_LIST, SET_GROUP_PANEL, SET_GROUP_STATUS, SET_LAST_GROUP_UPDATE_TIME } from "./actionType";
import { G_FOCUS_ITEM, G_PP_LIST, main_list } from "./constants";

const DEFAULT_STATE = {
    // group mode 
    status: false,
    // group panel open
    panel: false,
    list: new Array(),
    focusGroup: null,
    componentType: G_PP_LIST,
    participants: new Map(), 
    assignGroupId: "",
    lastUpdateTimestamp: null
};

ReducerRegistry.register("features/group", (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CONFERENCE_LEFT:
            return {
                // group mode 
                status: false,
                // group panel open
                panel: false,
                list: new Array(),
                focusGroup: null,
                componentType: G_PP_LIST,
                participants: new Map(),
                assignGroupId: ""
            }

        case CLEAR_GROUP_LIST:
            state.list =  new Array();
            return state;

        case INIT_GROUP_LIST:
            state.list = action.list;
            return state;

        case SET_GROUP_STATUS:
            return {
                ...state,
                status: action.status,
                panel: action.state ? state.panel : false,
            }

        case SET_GROUP_PANEL: 
            return {
                ...state,
                panel: action.panel
            }
            
        case SET_GROUP_LIST:
            action.list.map(item => {
                const itemIndex = state.list.findIndex(i => i.uuid === item.uuid);
                if (itemIndex !== -1) {
                    state.list.splice(itemIndex, 1);
                } 

                state.list = [...state.list, item];
            });
            
            return { ...state }

        case SET_ASSIGN_GROUP_ID:
            return {
                ...state, 
                assignGroupId: action.id
            }

        case SET_GROUP_FOCUS:
            const componentType = action.uuid ? G_FOCUS_ITEM : state.componentType;
            return {
                ...state,
                focusGroup: action.uuid,
                componentType
            }

        case SET_GROUP_COMPONENT_TYPE: 
            const focusGroup = main_list.indexOf(action.componentType) !== -1 ? null : state.focusGroup;

            return {
                ...state,
                componentType: action.componentType,
                focusGroup
            }

        case DELETE_GROUP_LIST:
            const index = state.list.findIndex(item => item.uuid === action.uuid);

            if (index !== -1) {
                state.list.splice(index, 1);
                
                return {
                    ...state,
                    list: [...state.list]
                }
            }

        case SET_LAST_GROUP_UPDATE_TIME:
            return {
                ...state, 
                lastUpdateTimestamp: action.time
            }    
    }

    return state;
});